import { action, observable } from 'mobx'

export default class RoomsConfigViewModel {
  @observable enabled = false

  @action
  activate() {
    this.enabled = true
  }

  toJSON() {
    return {
      enabled: true,
    }
  }
}
